
/**
 * 강의 콘텐츠 유형
 */
export type CreateCourseDraftBodySectionsItemLecturesItemContentType = typeof CreateCourseDraftBodySectionsItemLecturesItemContentType[keyof typeof CreateCourseDraftBodySectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraftBodySectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  CODING: 'CODING',
} as const;
